import { useTranslation } from "react-i18next";
import { ReadinessChecklist } from "./ReadinessChecklist";
import { AbsentNotice } from "./AbsentNotice";
import { TooEarlyNotice } from "./TooEarlyNotice";
import { OffDayNotice } from "./OffDayNotice";
import { GeoNotice } from "./GeoNotice";
import { QrScanStep } from "./QrScanStep";

// كل ما يُعرض بدل الكاميرا: انتظار نتيجة الفحص، أو بوابة مقفلة (غياب · وقت مبكر · عطلة · QR).
export const CaptureGateView = ({ waiting, gate, geoError, onClose, onQrCode }) => {
  const { t } = useTranslation();

  if (waiting) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-4 py-10" data-testid="capture-waiting">
        <ReadinessChecklist readiness={null} loading />
        {geoError ? (
          <p className="max-w-xs text-center text-xs font-bold text-destructive">{t("check.gpsDenied")}</p>
        ) : null}
      </div>
    );
  }
  if (gate.kind === "absent") return <AbsentNotice check={gate.check} onClose={onClose} />;
  if (gate.kind === "early") return <TooEarlyNotice check={gate.check} onClose={onClose} />;
  if (gate.kind === "offDay") return <OffDayNotice check={gate.check} onClose={onClose} />;
  if (gate.kind === "geo") return <GeoNotice check={gate.check} onClose={onClose} />;
  return <QrScanStep onCode={onQrCode} onClose={onClose} />;
};
